export const AUTH_UI_THEMES = {
  CLASSIC: "classic",
  STREAMLINED: "streamlined",
};

/**
 * Active login/register UI theme. Set via REACT_APP_AUTH_UI_THEME=classic|streamlined
 */
export function getAuthUiTheme() {
  const raw = String(process.env.REACT_APP_AUTH_UI_THEME || AUTH_UI_THEMES.CLASSIC)
    .trim()
    .replace(/\s+#.*$/, "")
    .trim()
    .toLowerCase();
  return raw === AUTH_UI_THEMES.STREAMLINED
    ? AUTH_UI_THEMES.STREAMLINED
    : AUTH_UI_THEMES.CLASSIC;
}
